/* ==========================================================================
   HIGH-VARIANT PRODUCTS (more than 250 variants)
   Liquid only hands the page the first 250 variants. When a shopper picks a
   combination that is not among them, ask Shopify for exactly that variant
   (?option_values=...), add it to the theme's live variants array
   (window.T4S_HV, exposed in theme.min.js) and to the hidden <select>, then
   replay the click so the theme's own code does the rest.
   Loaded by snippets/product-form.liquid only for products with > 250 variants.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__hvVariantsLoaded) return;
  window.__hvVariantsLoaded = true;

  var FLAG = 'hvReplay';
  var SEL = '[data-high-variant-product="true"]';

  function parseVal(v) {
    if (v === undefined) return undefined;
    try { return JSON.parse(v); } catch (e) { return v; }
  }

  function pickSelection(form, clicked) {
    var values = [], ids = [];
    Array.prototype.slice.call(form.querySelectorAll('[data-swatch-option]')).forEach(function (group) {
      var item = group.contains(clicked) ? clicked : group.querySelector('[data-swatch-item].is--selected');
      values.push(item ? item.getAttribute('data-value') : null);
      ids.push(item ? item.getAttribute('data-option-value-id') : null);
    });
    return { values: values, ids: ids };
  }

  function matches(variant, values) {
    for (var i = 0; i < values.length; i++) {
      if (values[i] !== null && String(variant['option' + (i + 1)]) !== String(values[i])) return false;
    }
    return true;
  }

  function replay(item) {
    item.dataset[FLAG] = '1';
    item.click();
  }

  function sectionIdFor(form, productUrl) {
    var path = location.pathname.replace(/\/$/, '');
    if (!productUrl || path !== productUrl.split('?')[0].replace(/\/$/, '')) return null;
    var wrap = form.closest('.shopify-section');
    return wrap && wrap.id ? wrap.id.replace(/^shopify-section-/, '') : null;
  }

  // the theme creates the live array when it initialises; wait briefly if a click comes first
  function getLive(productId) {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        var live = window.T4S_HV && window.T4S_HV[productId];
        if (live || tries++ > 30) return resolve(live || null);
        setTimeout(check, 100);
      })();
    });
  }

  async function loadVariant(form, sel) {
    var productId = form.getAttribute('data-hv-product-id');
    var productUrl = form.getAttribute('data-hv-product-url');
    var live = await getLive(productId);
    if (!live) {
      console.warn('[high-variant] window.T4S_HV missing - upload the patched assets/theme.min.js');
      return null;
    }
    if (live.some(function (v) { return matches(v, sel.values); })) return live;

    var ids = sel.ids.filter(Boolean);
    if (!ids.length || !productUrl) { console.warn('[high-variant] swatches have no data-option-value-id'); return live; }

    var url = new URL(productUrl, location.origin);
    url.searchParams.set('option_values', ids.join(','));
    var sectionId = sectionIdFor(form, productUrl);
    if (sectionId) url.searchParams.set('section_id', sectionId);

    var res = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!res.ok) throw new Error('variant request failed: ' + res.status);
    var doc = new DOMParser().parseFromString(await res.text(), 'text/html');

    var jsonEl = doc.querySelector('.pr_variants_json');
    if (!jsonEl) throw new Error('no variants json in response');
    var found = JSON.parse(jsonEl.textContent).filter(function (v) { return matches(v, sel.values); })[0];
    if (!found) { console.warn('[high-variant] no variant for', sel.values); return live; }

    var select = form.querySelector('select.t4s-product__select');
    var opt = select && select.querySelector('option[value="' + found.id + '"]');
    if (select && !opt) {
      var remote = doc.querySelector('select.t4s-product__select option[value="' + found.id + '"]');
      opt = remote ? document.importNode(remote, true) : document.createElement('option');
      opt.removeAttribute('selected');
      opt.value = found.id;
      if (!remote) opt.textContent = found.title;
      select.appendChild(opt);
    }

    var ds = (opt && opt.dataset) || {};
    found.incoming = ds.incoming === 'true' ? true : (parseVal(ds.incoming) || false);
    found.next_incoming_date = ds.nextincomingdate || null;
    found.inventory_policy = ds.inventorypolicy ? String(parseVal(ds.inventorypolicy)) : null;
    found.inventory_quantity = parseVal(ds.inventoryquantity);
    if (!live.some(function (v) { return v.id === found.id; })) live.push(found);
    return live;
  }

  document.addEventListener('click', function (event) {
    var item = event.target.closest(SEL + ' [data-swatch-item]');
    if (!item) return;

    if (item.dataset[FLAG]) { delete item.dataset[FLAG]; return; }   // our own replay
    if (item.classList.contains('is--selected')) return;

    var form = item.closest(SEL);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var sel = pickSelection(form, item);
    loadVariant(form, sel)
      .then(function (live) {
        // never hand the theme a combination it cannot find (that is what throws "reading 'id'")
        if (live && !live.some(function (v) { return matches(v, sel.values); })) {
          console.warn('[high-variant] combination not available:', sel.values);
          return;
        }
        replay(item);
      })
      .catch(function (e) { console.error('[high-variant]', e); });
  }, true);
})();
